import PrincipeColos from './PrincipeColos';

export default PrincipeColos;
